/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint ignore:start */
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import imag from "../images/logos/logo.png";
import imag3 from "../images/flag/united-kingdom.png";
import Crown from "../Icon/crown-alt.png";
import { Link, useNavigate } from "react-router-dom";
import { BiEditAlt } from "react-icons/bi";
import axios from "axios";
import { MyContext } from "../Context/MyProvider";
import { useTranslation } from "react-i18next";
import i18n from "../Language";
import { TodoContext } from "../Context";
import OneSignal from "react-onesignal";
import { IoCall } from "react-icons/io5";
import WebCallManager from "../User_Call/WebCallManager";
import { showTost } from "../showTost";
import verify from "../images/icons/verify.png";
import verify1 from "../images/icons/verify-1.png";
import Review from "../images/icons/information.png";
import { IoIosNotificationsOutline } from "react-icons/io";
import Slider from "react-slick";
import { IoMdClose } from "react-icons/io";
import UserChat from "./UserChat";
import SendMessage from "../images/icons/Chat-Icon.svg"
import Keepswiping from "../images/icons/keepswap.svg"
import { initiateSocket, disconnectSocket, getSocket } from "../socket";
import LodingLottie from "../Lodinglottie";
import { fetchProfileCompletion, getChatBlockMessage, getProfileCompletion } from "../utils/profileCompletion";
import { FiGift, FiMapPin, FiPhoneCall, FiSettings, FiUser, FiHome, FiHeart, FiShield, FiMessageSquare, FiFileText, FiLogOut, FiDisc, FiGlobe, FiChevronDown, FiCheck } from "react-icons/fi";
import { FaStar, FaBolt } from "react-icons/fa";
import GiftBubbleOverlay from "./GiftBubbleOverlay";
import EngagementModal from "./EngagementModal";

// Header component for navigation and user controls

const Header = () => {
  const Data = useContext(TodoContext);
  const { t, i18n } = useTranslation();
  const { imageBaseURL, basUrl, updateId, callStatus, color, setColor, chatId, setChatId, setCallstatus, setChatUserName, atendCall, setAtendCall, setOnesignalAppId, setAgoraAppId, socketDebugToast, setSocketDebugToast, setCallMode, setCallProvider, isSuperLikeMasterEnabled = true, isBoostMasterEnabled = true } = useContext(MyContext);
  const navigate = useNavigate();

  const [user, setUser] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [isVisible2, setIsVisible2] = useState(false);
  const [isVisible3, setIsVisible3] = useState(false);
  const [input, SetInput] = useState("");
  const [isIdentity, setIsIdentity] = useState(false);
  const [loading, setLoading] = useState(true);
  const [imageSelect, setImageSelect] = useState();
  const [profileimageshow, setProfileImageShow] = useState(false);
  const [isverify, setIsVerify] = useState("");
  const [list, setList] = useState([]);
  const [packageId, setPackageId] = useState();
  const [img, setImg] = useState(imag3);
  const [language, setLanguage] = useState("English");
  const [notification, setNotification] = useState();
  const [callType, setCallType] = useState('');
  const [callProPic, setCallProPic] = useState();
  const [likeMatch, setLikeMatch] = useState(false);
  const [totalLiked, setTotalLiked] = useState([]);
  const [myData, setMyData] = useState();
  const [showChat, setShowChat] = useState(false);
  const [giftAnimations, setGiftAnimations] = useState([]);
  const [profileCompletion, setProfileCompletion] = useState(getProfileCompletion());

  const [engagementBalance, setEngagementBalance] = useState({
    super_likes: 0,
    boosts: 0,
    super_boosts: 0,
    is_boost_active: "0",
    boost_remaining_seconds: 0,
  });
  const [isEngagementOpen, setIsEngagementOpen] = useState(false);
  const [engagementInitialType, setEngagementInitialType] = useState("SUPER_LIKE");
  const profileRatio = Math.max(
    0,
    Math.min(
      100,
      Number(profileCompletion?.completion_percent ?? localStorage.getItem("Profile_ratio") ?? 0),
    ),
  );

  const languageData = [
    { title: "English", img: require("../images/flag/united-kingdom.png"), id: "en" },
    { title: "Arabic", img: require("../images/flag/arabic.png"), id: "ar" },
    { title: "Spanish", img: require("../images/flag/spain.png"), id: "sp" },
    { title: "Hindi", img: require("../images/flag/flag.png"), id: "hi" },
    { title: "Gujarati", img: require("../images/flag/flag.png"), id: "gu" },
    { title: "Africans", img: require("../images/flag/south-africa.png"), id: "af" },
    { title: "Bengali", img: require("../images/flag/bangladesh.png"), id: "be" },
    { title: "Indonesian", img: require("../images/flag/indonesia-flag.png"), id: "in" }
  ];

  const newProfile = user && user.profile_pic;
  const Left = useRef();
  const Display = useRef();
  const Display2 = useRef();
  const BgDisplay2 = useRef();
  const InputRef = useRef();


  const ProfileRef = useRef();
  const Arrow = useRef();
  const oneSignalAppIdRef = useRef("");
  const oneSignalListenerAttachedRef = useRef(false);
  const activeCallRecoveryRef = useRef(false);

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const getRegisterUser = useCallback(() => {
    try {
      return JSON.parse(localStorage.getItem("Register_User") || "{}");
    } catch {
      return {};
    }
  }, []);

  const fetchEngagementBalance = useCallback(async () => {
    try {
      const regUser = getRegisterUser();
      const uid = localStorage.getItem("UserId") || regUser?.id || localStorage.getItem("Uid");
      if (!uid) return;
      const token = localStorage.getItem("token") || regUser?.token || "";
      const headers = { authorization: token ? `Bearer ${token}` : "" };
      let base = (basUrl || "").trim().replace(/\/+$/, "");
      if (base.toLowerCase().endsWith("/api")) {
        base = base.substring(0, base.length - 4);
      }
      const balanceRes = await axios.post(`${base}/api/engagement_balance`, { uid }, { headers });
      if (balanceRes.data && balanceRes.data.Result === "true") {
        setEngagementBalance({
          super_likes: balanceRes.data.super_likes || 0,
          boosts: balanceRes.data.boosts || 0,
          super_boosts: balanceRes.data.super_boosts || 0,
          is_boost_active: balanceRes.data.is_boost_active || "0",
          boost_remaining_seconds: balanceRes.data.boost_remaining_seconds || 0,
        });
      }
    } catch (err) {
      console.error("Error fetching engagement balance in Header:", err);
    }
  }, [basUrl, getRegisterUser]);

  useEffect(() => {
    fetchEngagementBalance();
  }, [fetchEngagementBalance]);

  useEffect(() => {
    let interval = null;
    if (engagementBalance.is_boost_active === "1" && engagementBalance.boost_remaining_seconds > 0) {
      interval = setInterval(() => {
        setEngagementBalance((prev) => {
          if (prev.boost_remaining_seconds <= 1) {
            return { ...prev, is_boost_active: "0", boost_remaining_seconds: 0 };
          }
          return { ...prev, boost_remaining_seconds: prev.boost_remaining_seconds - 1 };
        });
      }, 1000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [engagementBalance.is_boost_active, engagementBalance.boost_remaining_seconds]);

  useEffect(() => {
    const handleEngagementUpdate = () => {
      fetchEngagementBalance();
    };
    window.addEventListener("gomeet:engagement-updated", handleEngagementUpdate);
    window.addEventListener("gomeet:profile-action-recorded", handleEngagementUpdate);
    return () => {
      window.removeEventListener("gomeet:engagement-updated", handleEngagementUpdate);
      window.removeEventListener("gomeet:profile-action-recorded", handleEngagementUpdate);
    };
  }, [fetchEngagementBalance]);

  const formatBoostTime = (seconds) => {
    if (!seconds || seconds <= 0) return "0s";
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    if (m > 0) return `${m}m ${s}s`;
    return `${s}s`;
  };

  const changeLanguage = (lang) => {
    if (i18n && typeof i18n.changeLanguage === "function") {
      i18n.changeLanguage(lang);
    }
    sessionStorage.setItem("I18", lang);
  };

  const SelectLanuguageHandler = (img, name) => {
    setImg(img);
    setLanguage(name);
    sessionStorage.setItem("Language", JSON.stringify({ Name: name, img }));
  };

  const SlidBarHAndler = () => {
    if (window.innerWidth < 992) {
      if (isVisible) {
        Left.current.style.left = "-350px";
        BgDisplay2.current.style.display = "none";
      } else {
        Left.current.style.left = "0px";
        BgDisplay2.current.style.display = "block";
      }
      setIsVisible(!isVisible);
    }
  };

  const ShowHAndler = () => {
    if (isVisible2) {
      if (Display?.current) Display.current.style.display = "none";
      if (Display2?.current) Display2.current.style.display = "none";
      if (Arrow?.current) Arrow.current.classList.add("arrow");
    } else {
      if (Display?.current) Display.current.style.display = "block";
      if (Display2?.current) Display2.current.style.display = "block";
      if (Arrow?.current) Arrow.current.classList.remove("arrow");
    }
    setIsVisible2(!isVisible2);
  };

  const toggleBottomSheet = (e) => {
    setIsVisible3(e?.target?.id !== 'Verify');
  };

  useEffect(() => {
    sessionStorage.setItem("Loding", loading);
  }, [loading]);

  const ProfileHandler = (e) => {
    setProfileImageShow(e.target.id !== 'EditPhoto');
  };

  const SelectHandler = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageSelect(reader.result.split(",")[1]);
      };
      reader.readAsDataURL(file);
    }
  };

  const PhotoHandler = () => {
    const UserData = getRegisterUser();
    if (imageSelect && UserData.id) {
      axios.post(`${basUrl}pro_image`, { uid: UserData.id, img: imageSelect })
        .then((res) => {
          if (res.data.Result === "true") {
            localStorage.setItem("Register_User", JSON.stringify(res.data.UserLogin));
            showTost({ title: res.data.ResponseMsg });
            setProfileImageShow(false);
            window.location.href = '/';
          }
        });
    } else {
      showTost({ title: "Please Uplode Photo" });
    }
  };

  const ColorHandler = (Id) => {
    setColor(Id);
    sessionStorage.setItem("Icon-Color", Id);
  };

  const InputHandler = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      SetInput(`data:image/png;base64,${reader.result.split(",")[1]}`);
    };
    reader.readAsDataURL(file);
  };

  const VerificationHandler = () => {
    if (!input) {
      showTost({ title: "Uplode Photo!!" });
      return;
    }
    const parsedData = getRegisterUser();
    if (parsedData.identity_picture) {
      showTost({ title: "Verification Under Review!!" });
    } else if (parsedData.id) {
      axios.post(`${basUrl}identity_doc`, { uid: parsedData.id, img: input })
        .then((res) => {
          if (res.data.Result === "true") {
            localStorage.setItem("Register_User", JSON.stringify(res.data.UserLogin));
            showTost({ title: res.data.ResponseMsg });
            setIsVisible3(false);
            setIsIdentity(true);
            navigate("/");
          }
        });
    }
  };

  const ApiHandler = useCallback(() => {
    axios.post(`${basUrl}pagelist`)
      .then((res) => {
        setList(res.data.pagelist);
      });
  }, [basUrl]);

  const OneSignalNotificationHandle = useCallback(async (payload) => {
    if (payload.additionalData === undefined) return;
    if (payload.additionalData.Audio || payload.additionalData.vcId) {
      setCallType(payload.additionalData.Audio ? "Audio_Call" : "Video_Call");
      setNotification(payload.additionalData);
      setCallProPic(payload.additionalData.popic);
      setAtendCall(true);
    }
  }, [setAtendCall]);

  const handleNotificationReceived = useCallback((notification) => {
    OneSignalNotificationHandle(notification.notification);
  }, [OneSignalNotificationHandle]);

  const OneSignalHandle = useCallback(async (OneSignal_app_id) => {
    const appId = String(OneSignal_app_id || "").trim();
    const UserId = localStorage.getItem("UserId");
    if (appId && UserId) {
      try {
        if (oneSignalAppIdRef.current !== appId) {
          const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
          const notifyButtonConfig = {
            enable: true,
            position: 'bottom-right',
            size: 'medium',
            showCredit: false,
            text: {
              'tip.state.unsubscribed': 'Subscribe to notifications',
              'tip.state.subscribed': "You're subscribed to notifications",
              'tip.state.blocked': "You've blocked notifications",
              'message.action.subscribed': "Thanks for subscribing!",
              'message.action.resubscribed': "You're subscribed to notifications",
              'message.action.unsubscribed': "You won't receive notifications again",
              'dialog.main.title': 'Manage Notifications',
              'dialog.main.button.subscribe': 'SUBSCRIBE',
              'dialog.main.button.unsubscribe': 'UNSUBSCRIBE',
            }
          };

          if (isLocalhost) {
            await OneSignal.init({
              appId,
              notifyButton: notifyButtonConfig,
              allowLocalhostAsSecureOrigin: true,
            }).catch((err) => {
              console.warn("OneSignal localhost initialization notice:", err?.message || err);
            });
          } else if ("serviceWorker" in navigator) {
            const isHttps = window.location.protocol === "https:";
            if (isHttps) {
              await OneSignal.init({
                appId,
                notifyButton: notifyButtonConfig,
                serviceWorkerParam: { scope: "/" },
                serviceWorkerPath: "/OneSignalSDKWorker.js",
              }).catch((swErr) => {
                console.warn("OneSignal ServiceWorker initialization notice:", swErr?.message || swErr);
              });
            } else {
              await OneSignal.init({
                appId,
                notifyButton: notifyButtonConfig,
                allowLocalhostAsSecureOrigin: false,
              }).catch((swErr) => {
                console.warn("OneSignal HTTP dev mode notice:", swErr?.message || swErr);
              });
            }
          }
          oneSignalAppIdRef.current = appId;
        }

        if (OneSignal.Notifications?.requestPermission && OneSignal.Notifications.permission !== true) {
          await OneSignal.Notifications.requestPermission().catch(() => {});
        }
        if (OneSignal.Slidedown?.promptPush) {
          await OneSignal.Slidedown.promptPush().catch(() => {});
        }
        if (typeof OneSignal.login === "function") {
          await OneSignal.login(String(UserId)).catch(() => {});
        } else {
          console.warn("OneSignal.login is unavailable; external_id push targeting will not work on this SDK.");
        }
        if (OneSignal.User?.addTags) {
          await OneSignal.User.addTags({ "user_id": UserId }).catch(() => {});
        }
        if (!oneSignalListenerAttachedRef.current && OneSignal.Notifications?.addEventListener) {
          OneSignal.Notifications.addEventListener('foregroundWillDisplay', handleNotificationReceived);
          oneSignalListenerAttachedRef.current = true;
        }
      } catch (error) {
        console.warn("Error initializing OneSignal:", error);
      }
    }
  }, [handleNotificationReceived]);

  const GetKeyHandle = useCallback(() => {
    axios.post(`${basUrl}sms_type`)
      .then((res) => {
        setAgoraAppId(res.data.agora_app_id);
        setCallMode(res.data.call_mode || "audio_video");
        setCallProvider(res.data.call_provider || "agora");
        const oneSignalAppId = res.data.one_signal_app_id || res.data.one_key || "";
        setOnesignalAppId(oneSignalAppId);
        OneSignalHandle(oneSignalAppId);
        setSocketDebugToast(res.data.socket_debug_toast);
      })
      .catch(console.error);
  }, [OneSignalHandle, basUrl, setAgoraAppId, setCallMode, setCallProvider, setOnesignalAppId, setSocketDebugToast]);

  const LogOutHandler = () => {
    showTost({ title: "Logout Successfully!!" });
    disconnectSocket();
    try {
      OneSignal.logout();
    } catch (error) {
      console.error("OneSignal logout error:", error);
    }
    navigate("/Home");
    Data.setDemo(Data.demo + 1);
    localStorage.clear();
    sessionStorage.clear();
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    const loadingTimer = setTimeout(() => {
      setLoading(false);
      document.body.style.overflow = "auto";
    }, 2000);

    const UserData = getRegisterUser();
    if (UserData.id) {
      setUser(UserData);
      setIsVerify(UserData.is_verify);
      setColor(sessionStorage.getItem("Icon-Color") || "Home");
      fetchProfileCompletion(basUrl, UserData.id).then((completion) => {
        if (completion) setProfileCompletion(completion);
      });
      if (UserData.identity_picture) {
        SetInput(imageBaseURL + UserData.identity_picture);
        setIsIdentity(true);
      }
      setPackageId(UserData.plan_id > 0 ? UserData.plan_id : localStorage.getItem("PurchaseId"));
    }
    ApiHandler();

    return () => {
      clearTimeout(loadingTimer);
      document.body.style.overflow = "auto";
    };
  }, [ApiHandler, basUrl, getRegisterUser, imageBaseURL, setColor, updateId]);

  useEffect(() => {
    const handleProfileCompletionUpdated = (event) => {
      setProfileCompletion(event.detail || getProfileCompletion());
    };
    window.addEventListener("gomeet:profile-completion-updated", handleProfileCompletionUpdated);
    return () => {
      window.removeEventListener("gomeet:profile-completion-updated", handleProfileCompletionUpdated);
    };
  }, []);

  useEffect(() => {
    const handleUserUpdated = (event) => {
      const nextUser = event.detail || getRegisterUser();
      if (!nextUser?.id) return;
      setUser(nextUser);
      setIsVerify(nextUser.is_verify);
      setPackageId(nextUser.plan_id > 0 ? nextUser.plan_id : localStorage.getItem("PurchaseId"));
      if (nextUser.identity_picture) {
        SetInput(imageBaseURL + nextUser.identity_picture);
        setIsIdentity(true);
      }
    };
    window.addEventListener("gomeet:user-updated", handleUserUpdated);
    return () => {
      window.removeEventListener("gomeet:user-updated", handleUserUpdated);
    };
  }, [getRegisterUser, imageBaseURL]);

  useEffect(() => {
    const Data = sessionStorage.getItem("Language");
    if (Data) {
      const Json = JSON.parse(Data);
      setImg(Json.img);
      setLanguage(Json.Name);
    }
    const Lan = sessionStorage.getItem("I18");
    if (Lan) i18n.changeLanguage(Lan);

    GetKeyHandle();
  }, [GetKeyHandle, i18n]);

  const CallAnsuserHandler = async () => {
    const socket = getSocket();
    const callerId = notification?.id || notification?.callerId || notification?.caller_id;
    const channel = notification?.Audio || notification?.vcId || notification?.channel;
    if (callerId && channel && socket?.connected) {
      const payload = {
        callerId,
        channel,
        call_id: notification.call_id || notification.callId || "",
      };
      socket.timeout(5000).emit("call_accept", payload, (error, response) => {
        if (response?.status === "error") {
          console.error("Call accept failed:", error || response?.error);
          showTost({ title: response?.error || "Unable to accept call. Please try again." });
          return;
        }
        if (error) {
          console.warn("Call accept ack timed out, opening call because signal was emitted:", error);
        }
        setAtendCall(false);
        setCallstatus(true);
      });
      return;
    }
    showTost({ title: "Socket disconnected. Please refresh and try again." });
  };

  const leaveCallHandler = async () => {
    setAtendCall(false);

    const socket = getSocket();
    if (notification?.id && socket?.connected) {
      socket.emit("call_reject", {
        callerId: notification.id,
        channel: notification.Audio || notification.vcId,
        call_id: notification.call_id || notification.callId || "",
      });
      return;
    }
  };

  const restoreActiveCall = useCallback(async () => {
    const userData = getRegisterUser();
    if (!userData?.id || !userData?.token || activeCallRecoveryRef.current) return;
    activeCallRecoveryRef.current = true;

    try {
      const res = await axios.post(`${basUrl}active_call`, { uid: userData.id }, {
        headers: { Authorization: `Bearer ${userData.token}` },
      });
      const activeCall = res.data?.active_call;
      if (res.data?.Result !== "true" || !activeCall?.channel) {
        activeCallRecoveryRef.current = false;
        return false;
      }

      const isAudio = activeCall.type === "audio";
      const isIncoming = activeCall.direction === "incoming";
      const isRinging = activeCall.status === "ringing";
      const payload = {
        Audio: isAudio ? activeCall.channel : null,
        vcId: isAudio ? null : activeCall.channel,
        id: activeCall.other_id,
        name: activeCall.other_name,
        propic: activeCall.other_pic,
        call_id: activeCall.call_id || activeCall.id || "",
        callerId: activeCall.caller_id,
        receiverId: activeCall.receiver_id,
      };

      setCallType(isAudio ? "Audio_Call" : "Video_Call");
      setNotification(payload);
      setCallProPic(activeCall.other_pic || "");

      if (isIncoming && isRinging) {
        setCallstatus(false);
        setAtendCall(true);
      } else {
        setAtendCall(false);
        setCallstatus(true);
      }
      return true;
    } catch (error) {
      activeCallRecoveryRef.current = false;
      console.error("Unable to restore active call:", error);
      return false;
    }
  }, [basUrl, getRegisterUser, setAtendCall, setCallstatus]);

  useEffect(() => {
    let cancelled = false;
    let attempts = 0;
    let retryTimer;

    const retryRestore = async () => {
      if (cancelled) return;
      attempts += 1;
      const restored = await restoreActiveCall();
      if (!cancelled && !restored && attempts < 8) {
        retryTimer = setTimeout(retryRestore, 1500);
      }
    };

    retryRestore();

    return () => {
      cancelled = true;
      if (retryTimer) clearTimeout(retryTimer);
    };
  }, [restoreActiveCall]);

  useEffect(() => {
    const userData = getRegisterUser();
    if (!userData || !userData.token) return;

    const socket = initiateSocket(userData.token, socketDebugToast);

    const handleIncomingCall = (data) => {
      console.log("Incoming call received via socket:", data);
      const currentUid = String(userData.uid || userData.id || userData.user_id || "");
      if (data.callerId && currentUid && String(data.callerId) === currentUid) {
        console.log("Ignoring incoming call signal for self (caller)");
        return;
      }
      setCallType(data.type === "audio" ? "Audio_Call" : "Video_Call");
      setNotification({
        Audio: data.type === "audio" ? data.channel : null,
        vcId: data.type === "video" ? data.channel : null,
        id: data.callerId,
        name: data.callerName,
        propic: data.callerPic,
        call_id: data.call_id || data.callId || ""
      });
      setCallProPic(data.callerPic);
      setAtendCall(true);
    };

    const handleCallEnded = (data) => {
      console.log("Call ended signal received:", data);
      const activeChannel = notification?.Audio || notification?.vcId;
      if (!activeChannel) return;
      if (!data?.channel || String(activeChannel) !== String(data.channel)) {
        console.log("Ignoring call ended signal for mismatch channel:", data?.channel, "active:", activeChannel);
        return;
      }
      if (callStatus || atendCall) {
        console.log("Ignoring call ended signal in Header because call is currently active/accepted");
        return;
      }
      setAtendCall(false);
      setCallstatus(false);
    };

    const dispatchSocketEvent = (name, detail) => {
      window.dispatchEvent(new CustomEvent(`gomeet:${name}`, { detail }));
    };

    const showGiftAnimation = (type, data) => {
      const giftImg = data?.giftImg || data?.gift_img || data?.giftImage || data?.gift_image || data?.image || data?.img;
      const coin = data?.coin || data?.gift_coin || data?.giftCoin || data?.total_coin || data?.totalCoin;
      const earning = data?.total_earning || data?.totalEarning || data?.earning_amount || data?.earningAmount;
      const currency = data?.currency || "";
      setGiftAnimations((items) => [
        ...items.slice(-2),
        {
          id: `${Date.now()}-${Math.random()}`,
          type,
          giftImg,
          coin,
          earning,
          currency,
        },
      ]);
    };

    const getSocketMatchProfile = (data, matchedUserId) => {
      const id = String(matchedUserId);
      const profileMap = data?.profiles;
      if (profileMap && profileMap[id]) return profileMap[id];

      const candidates = [
        data?.actor,
        data?.target,
        data?.user1_profile,
        data?.user2_profile,
      ];

      return candidates.find((profile) => String(profile?.profile_id) === id) || null;
    };

    const formatMatchedProfile = (matchedProfile) => ({
      profile_id: String(matchedProfile.profile_id),
      profile_name: matchedProfile.profile_name,
      profile_bio: matchedProfile.profile_bio,
      profile_age: matchedProfile.profile_age,
      profile_pic: matchedProfile.profile_pic || (matchedProfile.profile_images || [])[0] || "",
      profile_images: matchedProfile.profile_images || [],
      match_ratio: parseFloat(matchedProfile.match_ratio) || 100,
      is_verify: matchedProfile.is_verify
    });

    const handleMatchCreated = async (data) => {
      console.log("Match created via socket in Header:", data);
      dispatchSocketEvent("match-created", data);
      try {
        const myId = String(userData.id);
        const matchedUserId = String(data.user1) === myId ? String(data.user2) : String(data.user1);
        const socketProfile = getSocketMatchProfile(data, matchedUserId);

        if (socketProfile) {
          setTotalLiked([formatMatchedProfile(socketProfile)]);
          setLikeMatch(true);
          return;
        }

        const response = await axios.post(`${basUrl}profile_info`, {
          uid: myId,
          profile_id: matchedUserId,
          lats: "0",
          longs: "0",
        });

        if (response.data.Result === "true") {
          const matchedProfile = response.data.profileinfo;
          setTotalLiked([formatMatchedProfile(matchedProfile)]);
          setLikeMatch(true);
        }
      } catch (error) {
        console.error("Error handling socket match_created in Header:", error);
      }
    };

    const handleProfileActionRecorded = (data) => {
      dispatchSocketEvent("profile-action-recorded", data);
    };

    const handleProfileLiked = (data) => {
      dispatchSocketEvent("profile-liked", data);
      showTost({ title: "Someone liked your profile!" });
    };

    const handleGiftReceived = (data) => {
      dispatchSocketEvent("gift-received", data);
      showGiftAnimation("received", data);
    };

    const handleGiftSent = (data) => {
      dispatchSocketEvent("gift-sent", data);
      showGiftAnimation("sent", data);
    };

    const handleFavouriteToggled = (data) => {
      dispatchSocketEvent("favourite-toggled", data);
      showTost({ title: data?.isFavourite ? "Profile added to favourites!" : "Profile removed from favourites!" });
    };

    socket.on("incoming_call", handleIncomingCall);
    socket.on("call_ended", handleCallEnded);
    socket.on("match_created", handleMatchCreated);
    socket.on("profile_action_recorded", handleProfileActionRecorded);
    socket.on("profile_liked", handleProfileLiked);
    socket.on("gift_sent", handleGiftSent);
    socket.on("gift_received", handleGiftReceived);
    socket.on("favourite_toggled", handleFavouriteToggled);
    restoreActiveCall();

    return () => {
      socket.off("incoming_call", handleIncomingCall);
      socket.off("call_ended", handleCallEnded);
      socket.off("match_created", handleMatchCreated);
      socket.off("profile_action_recorded", handleProfileActionRecorded);
      socket.off("profile_liked", handleProfileLiked);
      socket.off("gift_sent", handleGiftSent);
      socket.off("gift_received", handleGiftReceived);
      socket.off("favourite_toggled", handleFavouriteToggled);
    };
  }, [basUrl, getRegisterUser, notification?.Audio, notification?.vcId, restoreActiveCall, setAtendCall, setCallstatus, socketDebugToast]);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = String(position.coords.latitude);
          const long = String(position.coords.longitude);

          const HomeDataGetHandle = async () => {
            const userData = getRegisterUser();
            if (userData.id) {
              setMyData({
                name: userData.name,
                pro_pic: userData.profile_pic
              });
              try {
                const response = await axios.post(`${basUrl}home_data`, {
                  uid: userData.id,
                  lats: lat,
                  longs: long,
                });
                if (response.data.Result === "true") {
                  setTotalLiked(response.data.totalliked);
                  if (response.data.totalliked.length > 0) {
                    setLikeMatch(true);
                  }
                }
              } catch (error) {
                console.error("Error fetching user data:", error);
              }
            }
          };
          HomeDataGetHandle();
        }
      );
    }
  }, [basUrl, getRegisterUser]);

  const SendMessageHandle = async (id, name) => {
    const userData = getRegisterUser();
    const completion = await fetchProfileCompletion(basUrl, userData?.id);
    const chatBlockMessage = getChatBlockMessage(completion);
    if (chatBlockMessage) {
      showTost({ title: chatBlockMessage });
      navigate("/profile", {
        state: {
          profileCompletionRequired: true,
          missingTasks: completion?.missing_tasks || [],
        },
      });
      return;
    }
    if (sessionStorage.getItem("Icon-Color") !== "Home") {
      setShowChat(true);
    }
    setChatId(id);
    setChatUserName(name);
    ProfileViewHandle();
  };

  const KeepSwipingHandle = () => {
    ProfileViewHandle();
    navigate("/");
    ColorHandler("Home");
  };

  const ProfileViewHandle = async () => {
    const userData = getRegisterUser();
    if (userData.id) {
      try {
        for (let i = 0; i < totalLiked.length; i++) {
          await axios.post(`${basUrl}profile_view`, {
            "uid": userData.id,
            "profile_id": totalLiked[i].profile_id
          });
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }
    setLikeMatch(false);
  };

  const ChatCloseHandle = () => {
    setChatId("");
    sessionStorage.setItem("ChatId", "");
  };

  const renderLikeMatchItem = (item, useFallbackPic = false) => {
    const leftImg = useFallbackPic ? "images/img39.jpg" : item.profile_images[0];
    return (
      <div key={item.profile_id}>
        <h3 className="text-center text-[#980EFF] text-[20px]">You and <span className="text-[#9000ffb2]">{item.profile_name}</span> liked each other!</h3>
        <div className="flex items-center justify-center gap-2 mt-[50px]">
          <div className="text-center w-[165px] max-_430_:w-[135px]">
            <img src={imageBaseURL + leftImg} className="h-[200px] max-_430_:h-[180px] w-[150px] mx-auto z-[1] object-cover likematchleft border-[6px] border-[#980EFF]" alt="" />
            <h4 className="mt-[8px] overflow-ellipsis overflow-hidden whitespace-nowrap">{item.profile_name}</h4>
          </div>
          <div className="absolute flex items-center justify-center mt-[8px] p-[8px] rounded-full mb-[8px] bg-[#501368] z-[2]">
            <svg
              className="size-full w-[50px] -rotate-90"
              viewBox="0 0 36 36"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="18"
                cy="18"
                r="16"
                fill="none"
                className="stroke-current text-[#e7cdfab9]"
                strokeWidth="3"
              ></circle>
              <circle
                cx="18"
                cy="18"
                r="16"
                fill="none"
                className="stroke-current text-[#a32aff] dark:text-[#ac41ff]"
                strokeWidth="3"
                strokeDasharray="100"
                strokeDashoffset={100 - item.match_ratio.toFixed(0)}
                strokeLinecap="round"
              ></circle>
            </svg>
            <h6 className="m-0 absolute text-white text-[14px] p-[5px]">
              {item.match_ratio.toFixed(0)}%
            </h6>
          </div>
          <div className="text-center w-[165px] max-_430_:w-[135px]">
            {myData?.pro_pic
              ? <img src={imageBaseURL + myData.pro_pic} className="h-[200px] max-_430_:h-[180px] w-[150px] mx-auto z-[1] object-cover likematchright" alt="" />
              : <div className="h-[200px] bg-gray-300 font-[500] text-[50px] max-_430_:h-[180px] w-[150px] mx-auto z-[1] object-cover likematchright flex items-center justify-center">
                {user?.name?.charAt(0).toUpperCase()}
              </div>}
            <h4 className="mt-[8px] overflow-ellipsis overflow-hidden whitespace-nowrap ">{myData?.name}</h4>
          </div>
        </div>
        <button onClick={() => SendMessageHandle(item.profile_id, item.profile_name)} className="likeMatchButton mt-[30px] mx-auto">
          <img src={SendMessage} alt="" />
          <h6 className="m-0">Send a message</h6>
        </button>
        <button onClick={KeepSwipingHandle} className="likeMatchButton mt-[10px] mx-auto">
          <img src={Keepswiping} alt="" />
          <h6 className="m-0">Keep Swiping</h6>
        </button>
      </div>
    );
  };

  return (
    <div style={{ userSelect: "none", cursor: "default" }}>
      {giftAnimations.map((animation) => (
        <GiftBubbleOverlay
          key={animation.id}
          animation={animation}
          imageBaseURL={imageBaseURL}
          onDone={() => setGiftAnimations((items) => items.filter((item) => item.id !== animation.id))}
        />
      ))}
      <header className="header-wrapper">
        <div className="main-header-container border-b-[1px] container-fluid px-md-4 px-3 h-[75px]">
          <div className="header-content-left">
            <div className="header-element">
              <button
                onClick={SlidBarHAndler}
                className="btn sidemenu-toggle d-lg-none p-0"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  width="20"
                  height="20"
                >
                  <path d="M12 3V7H3V3H12ZM16 17V21H3V17H16ZM22 10V14H3V10H22Z"></path>
                </svg>
              </button>
            </div>
          </div>

          <div className="header-content-right flex items-center gap-1.5 sm:gap-3">
            {/* Dynamic Super Like Counter Button */}
            {isSuperLikeMasterEnabled && (
              <button
                onClick={() => {
                  setEngagementInitialType("SUPER_LIKE");
                  setIsEngagementOpen(true);
                }}
                title={t("Super Likes")}
                className="flex items-center gap-1 sm:gap-1.5 bg-blue-50/90 hover:bg-blue-100/90 border border-blue-200/90 text-blue-700 font-bold px-2 py-1 sm:px-3 sm:py-1.5 rounded-full transition-all duration-200 shadow-xs cursor-pointer text-[11px] sm:text-xs shrink-0"
              >
                <FaStar className="text-blue-500 text-xs sm:text-sm" />
                <span>{engagementBalance.super_likes}</span>
              </button>
            )}

            {/* Dynamic Boost Counter Button */}
            {isBoostMasterEnabled && (
              <button
                onClick={() => {
                  setEngagementInitialType("BOOST");
                  setIsEngagementOpen(true);
                }}
                title={t("My Boosts")}
                className={`flex items-center gap-1 sm:gap-1.5 font-bold px-2 py-1 sm:px-3 sm:py-1.5 rounded-full transition-all duration-200 shadow-xs cursor-pointer text-[11px] sm:text-xs shrink-0 ${
                  engagementBalance.is_boost_active === "1" && engagementBalance.boost_remaining_seconds > 0
                    ? "bg-purple-600 text-white animate-pulse border border-purple-400"
                    : "bg-purple-50/90 hover:bg-purple-100/90 border border-purple-200/90 text-purple-700"
                }`}
              >
                <FaBolt className={engagementBalance.is_boost_active === "1" && engagementBalance.boost_remaining_seconds > 0 ? "text-yellow-300 text-xs sm:text-sm animate-bounce" : "text-purple-600 text-xs sm:text-sm"} />
                <span>
                  {engagementBalance.is_boost_active === "1" && engagementBalance.boost_remaining_seconds > 0
                    ? formatBoostTime(engagementBalance.boost_remaining_seconds)
                    : engagementBalance.boosts}
                </span>
              </button>
            )}

            <div className="header-element shrink-0">
              <Link onClick={() => ColorHandler("Upgrade")}
                to="/upgrade"
                title={t("Upgrade Now")}
                style={{ background: "rgba(152,14,255,255)" }}
                className="btn text-white gap-1 df-center rounded-full p-2 sm:px-4 sm:py-2 font-semibold shadow-xs hover:opacity-90 transition-opacity"
              >
                <svg
                  width="18"
                  height="14"
                  viewBox="0 0 20 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="sm:w-[20px] sm:h-[15px]"
                >
                  <path
                    d="M18.1965 12.3945L17.8358 13.959C17.762 14.2782 17.4779 14.5039 17.1502 14.5039H3.08775C2.7601 14.5039 2.47603 14.2782 2.40221 13.959L2.0415 12.3945H18.1965Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M19.9447 4.81846L18.5209 10.9884H1.71619L0.292359 4.81846C0.229781 4.54635 0.333843 4.26228 0.55814 4.09564C0.78314 3.929 1.08478 3.91142 1.32665 4.04994L5.67829 6.53689L9.53282 0.7551C9.65868 0.566662 9.8668 0.449944 10.0925 0.441506C10.3203 0.431662 10.5348 0.534319 10.6733 0.712912L15.1937 6.52494L18.8689 4.07525C19.1087 3.91635 19.4216 3.91775 19.6585 4.08158C19.8962 4.24541 20.0087 4.53791 19.9447 4.81846Z"
                    fill="currentColor"
                  ></path>
                </svg>
                <span className="fs-13 d-sm-block d-none">{t('Upgrade Now')}</span>
              </Link>
            </div>

            <div
              onClick={async () => {
                ColorHandler("Notification");
                try {
                  if (typeof window !== "undefined" && window.OneSignal) {
                    if (window.OneSignal.Notifications?.requestPermission && window.OneSignal.Notifications.permission !== true) {
                      await window.OneSignal.Notifications.requestPermission();
                    } else if (window.OneSignal.Slidedown?.promptPush) {
                      await window.OneSignal.Slidedown.promptPush();
                    }
                  }
                } catch (_) {}
              }}
              className="flex items-center shrink-0"
            >
              <Link
                to="/notification"
                title="Notifications & Push Permission"
                className="relative flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 bg-purple-50/90 hover:bg-purple-100/90 border border-purple-200/90 hover:border-purple-300 rounded-full transition-all duration-200 shadow-xs cursor-pointer group"
              >
                <IoIosNotificationsOutline className="text-[18px] sm:text-[22px] text-purple-700 group-hover:text-purple-900 transition-colors" />
              </Link>
            </div>

            <div className="header-element relative shrink-0">
              <div className="dropdown relative">
                <button
                  onClick={ShowHAndler}
                  className="flex items-center gap-1 sm:gap-2.5 bg-gray-50 hover:bg-purple-50/80 border border-gray-200/90 hover:border-purple-200 p-1.5 sm:px-3.5 sm:py-1.5 rounded-full transition-all duration-200 shadow-xs cursor-pointer group"
                  type="button"
                  id="dropdownMenuButton1"
                  title={language}
                >
                  <img src={img} alt={language} className="w-5 h-5 rounded-full object-cover shadow-xs border border-white group-hover:scale-110 transition-transform" />
                  <span className="font-semibold text-sm text-gray-800 tracking-tight hidden sm:inline">{language}</span>
                  <FiChevronDown className={`text-gray-500 text-xs sm:text-base transition-transform duration-200 ${isVisible2 ? "rotate-180 text-purple-600" : ""}`} />
                </button>

                <ul
                  ref={Display}
                  style={{
                    display: isVisible2 ? "block" : "none",
                    right: "0px",
                    left: "auto",
                    top: "calc(100% + 12px)",
                    inset: "calc(100% + 12px) 0px auto auto",
                    transform: "none",
                    WebkitTransform: "none"
                  }}
                  className={`dropdown-menu border-0 shadow-2xl rounded-2xl bg-white/95 backdrop-blur-xl p-2 z-[99999] min-w-[170px] sm:min-w-[210px] animate-fade-in right-0 left-auto ${isVisible2 ? "show" : ""}`}
                  aria-labelledby="dropdownMenuButton1"
                >


                  {languageData.map((el, index) => {
                    const isSelected = language === el.title;
                    return (
                      <li
                        key={index}
                        onClick={() => { changeLanguage(el.id); SelectLanuguageHandler(el.img, el.title); ShowHAndler(); }}
                        className={`cursor-pointer rounded-xl px-3 py-2 my-0.5 flex items-center justify-between transition-all duration-150 group ${
                          isSelected
                            ? "bg-purple-50 text-purple-900 font-semibold border border-purple-100/60"
                            : "hover:bg-gray-50 text-gray-700 hover:text-purple-700"
                        }`}
                      >
                        <div className="flex items-center gap-2.5">
                          <img
                            src={el.img}
                            alt={el.title}
                            className="w-5 h-5 rounded-full object-cover shadow-xs group-hover:scale-110 transition-transform"
                          />
                          <span className="text-sm font-medium">{el.title}</span>
                        </div>
                        {isSelected && (
                          <FiCheck className="text-purple-600 text-base font-bold" />
                        )}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>

      <aside ref={Left} className="app-sidebar sticky" id="sidebar">
        <div className="sidebar-header df-center position-relative">
          <button onClick={() => { ColorHandler("Home"); SlidBarHAndler() }}>
            <Link to="/" className="flex justify-center">
              <img src={imag} alt="logo" className="w-[75%]" />
            </Link>
          </button>
          <button
            onClick={SlidBarHAndler}
            className="btn-close-sidebar d-lg-none text-[rgba(152,14,255,255)]"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
              width="28"
              height="28"
            >
              <path
                d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm79 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
                fill="currentColor"
              ></path>
            </svg>
          </button>
        </div>

        <div className="main-sidebar scroll-container" id="sidebar-scroll">
          <div className="text-right">
            <div className="rounded-full py-[2px] px-[7px] bg-[rgba(152,14,255,255)] inline-block ">
              <button
                onClick={() => { ColorHandler("Profile"); SlidBarHAndler(); navigate('/profile'); }}
                className="text-end text-white flex items-center"
              >
                {t('Edit')} <BiEditAlt className="ms-1" />
              </button>
            </div>
          </div>
          <div className="login-user-profile df-center flex-column mt-3">
            {packageId > 0 && <div className="bg-white p-[3px] rounded-full -mb-[20px] z-[555]">
              <img
                src={Crown}
                style={{ width: "25px", height: "25px" }}
                alt="user-avatar"
                className="bg-[rgba(152,14,255,255)] rounded-full p-[2px]"
              />
            </div>}
            <div className="relative size-40 w-[114px]">
              <svg
                className="size-full -rotate-90"
                viewBox="0 0 36 36"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="18"
                  cy="18"
                  r="16"
                  fill="none"
                  className="stroke-current text-transparent"
                  strokeWidth="2"
                ></circle>
                <circle
                  cx="18"
                  cy="18"
                  r="16"
                  fill="none"
                  className="stroke-current text-[rgba(152,14,255,255)] dark:text-[rgba(152,14,255,255)]"
                  strokeWidth="2"
                  strokeDasharray="100"
                  strokeDashoffset={100 - profileRatio}
                  strokeLinecap="round"
                ></circle>
              </svg>
              <div
                onClick={() => { ColorHandler("Profile"); SlidBarHAndler(); navigate('/profile'); }}
                className="absolute top-[66px] cursor-pointer start-[66px] transform -translate-y-1/2 -translate-x-1/2 w-full h-full"
              >
                {newProfile ? (
                  <img
                    src={`${imageBaseURL}${newProfile}`}
                    alt="User Avatar"
                    className="mb-3 rounded-circle bg-center"
                  />
                ) : (
                  <div className="bg-gray-300 rounded-circle w-[6rem] h-[6rem] flex justify-center items-center text-[32px] font-bold">
                    {user?.name?.charAt(0).toUpperCase()}
                  </div>
                )}
              </div>
            </div>
            <div className="bg-white py-[2px] px-[4px] rounded-full -mt-[20px] z-[777]">
              <span className="bg-[rgba(152,14,255,255)] text-white rounded-full px-[5px]">
                {profileRatio + '%'}
              </span>
            </div>
            <h3 className="fw-semi-bold flex items-center gap-[5px] m-0">
              {user?.name}
              <button onClick={toggleBottomSheet}>
                {isverify === "1"
                  ? <div className="tooltip pt-[5px]">
                    <img src={Review} style={{ width: "30px", height: "30px" }} alt="" />
                    <span className="tooltiptext -bottom-[35px] left-[8px] whitespace-nowrap">{t('Under Review')}</span>
                  </div>
                  : isverify === "2"
                    ? <div className="tooltip pt-[5px]">
                      <img src={verify} style={{ width: "30px", height: "30px" }} alt="" />
                      <span className="tooltiptext  -bottom-[35px] left-[10px] whitespace-nowrap">{t('Is Verify')}</span>
                    </div>
                    : <div className="tooltip pt-[5px]">
                      <img src={verify1} style={{ width: "30px", height: "30px" }} alt="" />
                      <span className="tooltiptext -bottom-[35px] -left-[10px] whitespace-nowrap">{t('Upload Photo')}</span>
                    </div>
                }
              </button>{" "}
            </h3>
            <p className="text-gray">{user?.email} </p>
          </div>
          <hr />

          <div className="sidebar-content">
            <nav className="navbar navbar-expand-lg navbar-light p-0">
              <div className="container-fluid px-0">
                <div className="navbar-collapse" id="navbarNav">
                  <ul className="navbar-nav flex-column mb-2 mb-lg-0">
                    <li onClick={() => { ColorHandler("Home"); SlidBarHAndler() }} className="Hover">
                      <Link to="/" className="nav-link" aria-current="page">
                        <FiHome
                          className="w-[20px] h-[20px] transition-colors"
                          style={{ color: color === "Home" ? "rgba(152,14,255,255)" : "#25314C" }}
                        />
                        <span style={{ color: color === "Home" && "rgba(152,14,255,255)" }}>{t("Home")}</span>
                      </Link>
                    </li>
                    <li onClick={() => { ColorHandler("Explore"); SlidBarHAndler() }} className="Hover">
                      <Link to="/explore" className="nav-link">
                        <FiHeart
                          className="w-[20px] h-[20px] transition-colors"
                          style={{ color: color === "Explore" ? "rgba(152,14,255,255)" : "#25314C" }}
                        />
                        <span style={{ color: color === "Explore" && "rgba(152,14,255,255)" }}>{t("Explore")}</span>
                      </Link>
                    </li>
                    <li onClick={() => { ColorHandler("Map"); SlidBarHAndler() }} className="Hover">
                      <Link to="/map" className="nav-link">
                        <FiMapPin
                          className="w-[20px] h-[20px] transition-colors"
                          style={{ color: color === "Map" ? "rgba(152,14,255,255)" : "#25314C" }}
                        />
                        <span style={{ color: color === "Map" && "rgba(152,14,255,255)" }}>{t("Map")}</span>
                      </Link>
                    </li>
                    <li onClick={() => { ColorHandler("Profile"); SlidBarHAndler() }} className="Hover">
                      <Link to="/profile" className="nav-link">
                        <FiUser
                          className="w-[20px] h-[20px] transition-colors"
                          style={{ color: color === "Profile" ? "rgba(152,14,255,255)" : "#25314C" }}
                        />
                        <span style={{ color: color === "Profile" && "rgba(152,14,255,255)" }}>{t("Profile")}</span>
                      </Link>
                    </li>
                    <li onClick={() => { ColorHandler("Settings"); SlidBarHAndler() }} className="Hover">
                      <Link to="/setting" className="nav-link">
                        <FiSettings
                          className="w-[20px] h-[20px] transition-colors"
                          style={{ color: color === "Settings" ? "rgba(152,14,255,255)" : "#25314C" }}
                        />
                        <span style={{ color: color === "Settings" && "rgba(152,14,255,255)" }}>{t("Settings")}</span>
                      </Link>
                    </li>
                    <li onClick={() => { ColorHandler("BuyCoin"); SlidBarHAndler() }} className="Hover">
                      <Link to="/buycoin" className="nav-link">
                        <FiDisc
                          className="w-[20px] h-[20px] transition-colors"
                          style={{ color: color === "BuyCoin" ? "rgba(152,14,255,255)" : "#25314C" }}
                        />
                        <span style={{ color: color === "BuyCoin" && "rgba(152,14,255,255)" }}>{t("Buy Coin")}</span>
                      </Link>
                    </li>
                    <li onClick={() => { ColorHandler("MyGift"); SlidBarHAndler() }} className="Hover">
                      <Link to="/mygift" className="nav-link">
                        <FiGift
                          className="w-[20px] h-[20px] transition-colors"
                          style={{ color: color === "MyGift" ? "rgba(152,14,255,255)" : "#25314C" }}
                        />
                        <span style={{ color: color === "MyGift" && "rgba(152,14,255,255)" }}>{t("My Gift")}</span>
                      </Link>
                    </li>
                    <li onClick={() => { ColorHandler("CallHistory"); SlidBarHAndler() }} className="Hover">
                      <Link to="/callhistory" className="nav-link">
                        <FiPhoneCall
                          className="w-[20px] h-[20px] transition-colors"
                          style={{ color: color === "CallHistory" ? "rgba(152,14,255,255)" : "#25314C" }}
                        />
                        <span style={{ color: color === "CallHistory" && "rgba(152,14,255,255)" }}>{t("Call History")}</span>
                      </Link>
                    </li>
                    <li onClick={() => { ColorHandler("Account"); SlidBarHAndler() }} className="Hover">
                      <Link to="/blockUser" className="nav-link">
                        <FiShield
                          className="w-[20px] h-[20px] transition-colors"
                          style={{ color: color === "Account" ? "rgba(152,14,255,255)" : "#25314C" }}
                        />
                        <span style={{ color: color === "Account" && "rgba(152,14,255,255)" }}>{t("Account & Security")}</span>
                      </Link>
                    </li>
                    <li onClick={() => { ColorHandler("Chat"); SlidBarHAndler() }} className="Hover">
                      <Link to="/chat" className="nav-link">
                        <FiMessageSquare
                          className="w-[20px] h-[20px] transition-colors"
                          style={{ color: color === "Chat" ? "rgba(152,14,255,255)" : "#25314C" }}
                        />
                        <span style={{ color: color === "Chat" && "rgba(152,14,255,255)" }}>{t('User Chat')}</span>
                      </Link>
                    </li>
                    {list.map((item, index) => {
                      const Title = item.title.replace(/\s+/g, '_');
                      const FinalText = Title.toLowerCase();

                      return (
                        <li key={index} onClick={() => { ColorHandler(item.title); SlidBarHAndler(); }} className="Hover">
                          <Link to={`/page/${FinalText}`} className="nav-link">
                            <FiFileText
                              className="w-[20px] h-[20px] transition-colors"
                              style={{ color: color === item.title ? "rgba(152,14,255,255)" : "#25314C" }}
                            />
                            <span style={{ color: color === item.title && "rgba(152,14,255,255)" }}>{item.title}</span>
                          </Link>
                        </li>
                      );
                    })}
                    <li className="Hover">
                      <Link onClick={LogOutHandler} to='/' className="nav-link">
                        <FiLogOut
                          className="w-[20px] h-[20px] transition-colors"
                          style={{ color: "#25314C" }}
                        />
                        <span>{t("Log Out")}</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        </div>

        {/* Creative Fixed Bottom Membership Card */}
        <div className="p-3 bg-white/95 backdrop-blur-md border-t border-purple-100/80 z-10">
          <Link
            to="/upgrade"
            onClick={() => { ColorHandler("Upgrade"); SlidBarHAndler(); }}
            className="block group relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#8a0eff] via-[#7000d6] to-[#4c0099] p-3.5 text-white shadow-xl shadow-purple-900/20 border border-white/15 transition-all duration-300 hover:shadow-purple-500/30 hover:-translate-y-0.5"
          >
            {/* Background decorative glow */}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-white/15 rounded-full blur-2xl pointer-events-none group-hover:scale-150 transition-transform"></div>

            <div className="relative z-10 flex items-center justify-between gap-2 mb-2">
              <div className="flex items-center gap-2.5">
                <div className="w-8 h-8 rounded-xl bg-white/20 backdrop-blur-md flex items-center justify-center shadow-inner border border-white/20">
                  <img src={Crown} className="w-4 h-4 object-contain" alt="Crown" />
                </div>
                <div className="flex flex-col">
                  <span className="font-extrabold text-xs tracking-tight text-white leading-none mb-0.5">
                    {packageId > 0 ? t("VIP Active") : t("GoMeet Premium")}
                  </span>
                  <span className="text-[10px] text-purple-200/80 font-medium leading-none">
                    {packageId > 0 ? t("Premium Member") : t("Exclusive Access")}
                  </span>
                </div>
              </div>

              <span className="px-3 py-1.5 rounded-full bg-white text-purple-900 group-hover:bg-purple-50 font-bold text-[11px] shadow-sm transition-colors flex items-center gap-1 flex-shrink-0">
                {packageId > 0 ? t("View Plan") : t("Upgrade")}
              </span>
            </div>

            <p className="relative z-10 text-[11px] text-purple-100/90 font-medium m-0 leading-tight">
              {packageId > 0 ? t("Enjoy premium benefits & match anytime") : t("Unlock unlimited matches & VIP features")}
            </p>
          </Link>
        </div>
      </aside>

      {isVisible3 && (
        <div onClick={toggleBottomSheet} id="Verify" className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
          <div onClick={(e) => e.stopPropagation()} className="w-[25%] max-_430_:w-[100%] max-_768_:w-[80%] max-_1030_:w-[45%] max-_1500_:w-[30%] bg-white rounded-[15px] px-[15px] py-[10px]">
            <div className="flex flex-col justify-center items-center text-center">
              <div
                onClick={() => InputRef.current.click()}
                className="w-[138px] cursor-pointer border-2 border-dotted p-2 border-gray-400 rounded-full"
              >
                <div className="bg-gray-200 flex items-center justify-center h-[115px] rounded-full">
                  {input ? (
                    <img
                      src={input}
                      className="w-full h-full rounded-full object-cover"
                      alt=""
                    />
                  ) : (
                    <h2 className="m-0 font-medium text-3xl">+</h2>
                  )}
                  <input disabled={input && true}
                    ref={InputRef}
                    className="hidden"
                    type="file"
                    accept="image/*"
                    onChange={(e) => e.target.files[0] && InputHandler(e)}
                  />
                </div>
              </div>
              {isIdentity ? (
                <div className="mt-4">
                  <h3>{t('Verification Under')} <br /> {t('Review')}</h3>
                  <p className="font-medium text-lg">
                    {t('We are currently reviewing your')} <br /> {t('selfies and will get back to you')} <br /> {t("shortly!")}
                  </p>
                </div>
              ) : (
                <div className="mt-4">
                  <h3>{t("Get Photo Verified")}</h3>
                  <h4>{t("We want to know its really you.")}</h4>
                  <h4 className="mb-[2px]">{t("Take a quick Image selfie")}</h4>
                  <p className="text-gray-500 text-[16px]">{t("Confrim youre the person in your photos.")}</p>
                </div>
              )}
              <button
                onClick={VerificationHandler}
                className="font-medium text-lg bg-[#980EFF] text-white w-[60%] max-w-[75%] rounded-lg py-2 my-4"
              >
                {t('Upload')}
              </button>
            </div>
          </div>
        </div>
      )}

      {loading && (
        <div className="w-[100%] h-[100vh] bg-white fixed flex items-center justify-center top-0 left-0 right-0 bottom-0 z-[9999]">
          <LodingLottie ClassCss={"w-[20%] max-_430_:w-[100%] max-_770_:w-[50%] max-_1030_:w-[40%] max-_1145_:w-[30%] max-_1200_:w-[30%] max-_1300_:w-[30%]"} />
        </div>
      )}

      {profileimageshow && (
        <div onClick={ProfileHandler} id="EditPhoto" className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
          <div onClick={(e) => e.stopPropagation()} className="w-[25%] max-_430_:w-[100%] max-_768_:w-[80%] max-_1030_:w-[40%] max-_1500_:w-[30%] bg-white rounded-[15px] px-[15px] py-[10px]">
            <div className="flex flex-col justify-center items-center text-center">
              <div
                onClick={() => ProfileRef.current.click()}
                className="w-[138px] cursor-pointer border-[2px] border-dotted p-[10px] border-gray-400 rounded-full"
              >
                <div className="bg-[#e5e5e5] flex items-center justify-center h-[115px] rounded-full">
                  {imageSelect ? (
                    <img
                      src={`data:image/png;base64,${imageSelect}`}
                      className="w-[100%] h-[100%] rounded-full object-center"
                      alt=""
                    />
                  ) : (
                    <h2 className="m-0 font-[400] text-[30px]">+</h2>
                  )}
                  <input
                    ref={ProfileRef}
                    className="hidden"
                    type="file"
                    accept="image/*"
                    onChange={(e) => SelectHandler(e)}
                  />
                </div>
              </div>
              <div className="mt-[15px]">
                <h3>{t('Add Your Favorite Photo')}</h3>
              </div>
              <button
                onClick={PhotoHandler}
                className="font-[500] text-[18px] bg-[#980EFF] text-white w-[60%] max-_430_:w-[75%] rounded-[10px] py-[8px] my-[15px]"
              >
                {t('Add')}
              </button>
            </div>
          </div>
        </div>
      )}

      <div
        ref={BgDisplay2}
        onClick={SlidBarHAndler}
        id="overlay"
        class="overlay z-[777] duration-[1s]"
      ></div>

      <div
        ref={Display2}
        onClick={ShowHAndler}
        id="overlay"
        class="fixed top-0 left-0 right-0 bottom-0 hidden z-[333] duration-[1s]"
      ></div>

      {atendCall && <div className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-60 z-[999]">
        <div onClick={(e) => e.stopPropagation()} className="w-full max-w-[390px] rounded-[24px]">
          <div className="relative overflow-hidden rounded-[24px] border border-white/15 bg-[#15051f] text-white shadow-2xl">
            <div
              className="absolute inset-0 scale-110 bg-cover bg-center opacity-20 blur-[18px]"
              style={{ backgroundImage: `url(${imageBaseURL + callProPic})` }}
            ></div>
            <div className="absolute inset-0 bg-[linear-gradient(145deg,rgba(152,14,255,0.92),rgba(60,11,98,0.98)_55%,rgba(17,4,27,0.98))]"></div>
            <div className="absolute -right-20 -top-24 h-56 w-56 rounded-full bg-white/10 blur-3xl"></div>
            <div className="absolute -bottom-24 -left-16 h-56 w-56 rounded-full bg-[#ff4f8b]/20 blur-3xl"></div>
            <div className="relative z-[2] px-7 py-7 text-center">
              <div className="mb-6 flex items-center justify-between">
                <div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/12 px-3 py-2 text-xs font-semibold text-white/90 backdrop-blur-md">
                  <span className="h-2 w-2 rounded-full bg-[#33e681] shadow-[0_0_12px_rgba(51,230,129,0.8)]"></span>
                  {callType === "Audio_Call" ? "Incoming audio" : "Incoming video"}
                </div>
                <button
                  type="button"
                  onClick={leaveCallHandler}
                  title="Dismiss call"
                  aria-label="Dismiss call"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-white/80 transition duration-200 hover:bg-white/18 hover:text-white"
                >
                  x
                </button>
              </div>

              <div className="flex flex-col items-center">
                <div className="relative mb-5">
                  <span className="absolute inset-[-10px] animate-pulse rounded-full bg-white/18"></span>
                  <img
                    src={imageBaseURL + callProPic}
                    alt={notification.name || "Caller"}
                    className="relative h-28 w-28 rounded-full border-4 border-white object-cover shadow-2xl"
                  />
                </div>
                <h2 className="m-0 text-3xl font-bold leading-tight">{notification.name}</h2>
                <p className="m-0 mt-2 text-sm font-medium text-white/70">
                  {callType === "Audio_Call" ? "wants to talk with you" : "wants to see you"}
                </p>
              </div>

              <div className="mt-8 grid grid-cols-2 gap-3">
                <button
                  type="button"
                  onClick={CallAnsuserHandler}
                  className="flex h-14 items-center justify-center gap-2 rounded-2xl bg-[#20c96b] text-sm font-bold text-white shadow-[0_14px_30px_rgba(32,201,107,0.28)] transition duration-200 hover:-translate-y-0.5 hover:bg-[#16b85e]"
                >
                  <IoCall className="text-xl" />
                  Answer call
                </button>
                <button
                  type="button"
                  onClick={leaveCallHandler}
                  className="flex h-14 items-center justify-center gap-2 rounded-2xl bg-white/12 text-sm font-bold text-white transition duration-200 hover:-translate-y-0.5 hover:bg-[#ff3f64]"
                >
                  <IoCall className="rotate-[135deg] text-xl" />
                  Decline
                </button>
              </div>
              <p className="m-0 mt-5 text-xs font-medium text-white/45">
                {callType === "Audio_Call" ? "Microphone starts after you answer." : "Camera starts after you answer."}
              </p>
            </div>
          </div>
        </div>
      </div>}

      {callStatus && (
        <WebCallManager
          channel={notification.Audio || notification.vcId}
          isVideo={callType === "Video_Call"}
          isCaller={false}
          receiverId={notification.id}
          receiverName={notification.name}
          receiverPic={callProPic ? (callProPic.startsWith("http") ? callProPic : imageBaseURL + callProPic) : ""}
          onClose={() => setCallstatus(false)}
        />
      )}

      {likeMatch && (
        <div className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
          <div onClick={(e) => e.stopPropagation()} className="w-[25%] relative likeMatch bg-white max-_430_:w-[100%] p-[20px] max-_580_:w-[60%] max-_768_:w-[60%] max-_991_:w-[60%] max-_1030_:w-[50%] max-_1500_:w-[40%] rounded-[15px]">
            <button onClick={ProfileViewHandle} className="absolute -right-[8px] -top-[8px] bg-[#980EFF] p-[2px] rounded-full"><IoMdClose className="text-[22px] text-white" /></button>
            {totalLiked.length > 1 ? (
              <Slider {...settings}>
                {totalLiked?.map((item) => renderLikeMatchItem(item))}
              </Slider>
            ) : (
              totalLiked?.map((item) => renderLikeMatchItem(item, true))
            )}
          </div>
        </div>
      )}

      {(chatId && showChat) && (
        <div onClick={ChatCloseHandle} className="bottom-sheet z-[999]">
          <div onClick={(e) => e.stopPropagation()} style={{ width: "400px" }} className="bottom-sheet-content">
            <UserChat />
          </div>
        </div>
      )}

      <EngagementModal
        isOpen={isEngagementOpen}
        onClose={() => {
          setIsEngagementOpen(false);
          fetchEngagementBalance();
        }}
        baseUrl={basUrl}
        initialType={engagementInitialType}
      />
    </div>
  );
};

export default Header;
/* jshint ignore:end */
